import type {
  PickPageArticlesQueryResponse,
  PickPageArticlesQueryVariables,
} from '~/api/shopify/queries/pickPageArticles.generated';
import type { PickPageArticleNodeFragment } from '~/api/shopify/fragments/pickPageArticle.generated';
import type { IPickPageSource, IPickPageSourceParams } from '../../types';

import {
  PICK_PAGE_SORT_KEY,
  PICK_PAGE_IS_SORT_REVERSED,
  PICK_PAGE_PAGE_SIZE,
} from '../../constants';
import { PickPageArticlesDocument } from '~/api/shopify/queries/pickPageArticles.generated';
import { toPickPageItemFromArticle, toPickPageSearchQuery } from '../../utils';
import { usePickPageConnectionSource } from './usePickPageConnectionSource';

/** Every blog's articles in one listing — the blog is never narrowed, and each row carries its handle. */
export const usePickPageBlogPostSource = ({
  searchValue,
  isEnabled,
  templateAssetKeys,
}: IPickPageSourceParams): IPickPageSource =>
  usePickPageConnectionSource<
    PickPageArticlesQueryResponse,
    PickPageArticlesQueryVariables,
    PickPageArticleNodeFragment
  >({
    queryKey: 'pick-page-blog-post-infinity',
    document: PickPageArticlesDocument,
    toVariables: (after?: string) => ({
      first: PICK_PAGE_PAGE_SIZE,
      query: toPickPageSearchQuery(searchValue),
      sortKey: PICK_PAGE_SORT_KEY,
      reverse: PICK_PAGE_IS_SORT_REVERSED,
      after,
    }),
    searchValue,
    isEnabled,
    templateAssetKeys,
    toConnection: (response) => response.articles,
    toItem: toPickPageItemFromArticle,
  });
